import React from 'react';
import SubNavigation from './SubNavigation';
import Collapsible from '../Collapsible';
import { getColor } from '../../styling/mixins/colors';
import styled from 'styled-components';
import { translate } from '../../Services/translation';
import { SubNavigationLinkModel } from '../../Types/SubNavigationLinkModel';
import { fontFamilyBold } from '../../styling/variables/typography';

const StyledMobileCollapsible = styled(Collapsible)`
  border: 1px solid ${getColor('gray', 300)};
  border-radius: 4px;
  margin-bottom: 2.4rem;
  padding-bottom: 0 !important;
  background-color: ${getColor('white')};
  .toggle-collapsible {
    padding: 1.2rem;
  }
  .ReactCollapse--content {
    padding-bottom: 0 !important;
  }
  > label {
    ${fontFamilyBold}
    padding-left: 1.6rem !important;
    padding-right: 1.6rem !important;
  }
`;

const SubNavigationContainer = ({
  links,
  name,
  url,
}: SubNavigationLinkModel) => {
  return (
    <div>
      <div className="subnav--mobile">
        <StyledMobileCollapsible
          label={translate('subnavigation.mobile-title')}
        >
          <SubNavigation links={links} name={name} url={url} />
        </StyledMobileCollapsible>
      </div>
      <div className="subnav--desktop">
        <SubNavigation links={links} name={name} url={url} />
      </div>
    </div>
  );
};

export default SubNavigationContainer;
